// extracted by mini-css-extract-plugin
export default {"root":"MobileViewerBottomToolbar__root--1ppMw","bttnText":"MobileViewerBottomToolbar__bttnText--EcaGz","iconButton":"MobileViewerBottomToolbar__iconButton--2NeaX"};